// extracted by mini-css-extract-plugin
export default {"mainBox":"App_mainBox__tFKqo","rightBox":"App_rightBox__UL21q","contentBox":"App_contentBox__aiYhI"};